import { ReactElement, useState } from 'react';
import ServicesPanel from './ServicesPanel';
import ContainerPadded from './ContainerPadded';

interface IService {
    id: number;
    title: string;
    content: React.ReactNode;
}

const services: IService[] = [
    {
        id: 1,
        title: 'Less-than-Truckload',
        content: <p>When you need less-than-truckload (LTL) freight delivered, it’s important to use a service provider that operates efficiently, with multiple options and best-in-class service. Revell Logistics offers LTL solutions that meet your needs through a reliable transportation network of over 15 carriers.</p>
    },
    {
        id: 2,
        title: 'Full Truckload',
        content: <p>With a growing network of 95,000+ approved capacity providers, Revell Logistics has your freight covered. We pride ourselves on offering competitive rates and top-notch service. Brokerage options include Dry Van, Intermodal, Refrigerated, Flatbed, and more.</p>
    },
    {
        id: 3,
        title: 'Logistics Consulting',
        content: <p>We offer free logistics consulting. Revell Logistics will analyze your current transportation spend to find efficiencies and ways to cut costs. This service is completely free to all customers.</p>
    },
    {
        id: 4,
        title: 'Expedite',
        content: <p>When the cost of failure outweighs the cost of shipping, choose Revell Logistics to handle your precious cargo with speed, security and precision. With multiple services designed to move freight quickly and efficiently, we offer reliable solutions for shipments that require on-time delivery.</p>
    }
];

export default function Services() {
    const [open, setOpen] = useState('1');

    return (
        <ContainerPadded>
            <div className="container">
                <div className='row'>
                    <h1>Services</h1>
                    <p>Revell Logistics Solutions is a full service logistics company that provides a wide range of services to meet all of your shipping needs. We are a family owned and operated business that has been in the industry for over 20 years. We pride ourselves on providing the best customer service in the industry. We are available 24/7 to answer any questions you may have. We look forward to working with you!</p>
                </div>
                <div className="row">
                    {services.map((service) => {
                        return (
                            <div key={service.id} className="col">
                                <ServicesPanel title={service.title}>
                                    {service.content}
                                </ServicesPanel>
                            </div>
                        );
                    })}
                </div>
            </div>
        </ContainerPadded>
    );
}
